import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const squidex = defineConnector({
  identifier: "squidex",
  name: "Squidex",
  tagLine: "Headless CMS and content platform",
  logo,
  protocol: "http",
  tags: ["engineering", "data"],
  defaultUrlPattern: ({ host }) =>
    host
      ? `https://${host.replace(/\./g, "\\.")}/.*`
      : "https://cloud\\.squidex\\.io/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a client",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your Squidex app, navigate to **Settings > Clients**, and create a new client. Copy the client ID and secret.",
        },
      ],
    },
    {
      title: "Enter your instance URL",
      items: [
        {
          kind: "input",
          label: "Squidex host",
          placeholder: "cloud.squidex.io",
          required: true,
          target: { kind: "configuration", field: "host" },
        },
      ],
    },
    {
      title: "Enter your client credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: ({ host }) =>
      `https://${host}/identity-server/connect/token`,
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
    scopes: () => ["squidex-api"],
  },
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `https://${host}/api/ping`,
  },
});
